export const frontendTechStack = [
    {
      img: "https://taher-ahmed.vercel.app/html-5.svg",
      name: "HTML 5",
    },
    {
      img: "https://taher-ahmed.vercel.app/css-3.svg",
      name: "CSS 3",
    },
    {
      img: "https://taher-ahmed.vercel.app/javascript.svg",
      name: "JavaScript",
  },
  {
    img: `https://upload.wikimedia.org/wikipedia/commons/thumb/4/4c/Typescript_logo_2020.svg/512px-Typescript_logo_2020.svg.png?20210506173343`,
    name:"Typescript"
    },
    {
      img: `logo512.png`,
      
      name: "React",
  },
  {
    img: `https://raw.githubusercontent.com/Rohan-Shakya/Rohan-Shakya/master/images/next_logo.png`,
    name:"Nextjs"
     },
    {
      img: "https://taher-ahmed.vercel.app/redux.svg",
      name: "Redux",
    },
   
  {
    img: `https://cdn.icon-icons.com/icons2/2699/PNG/512/tailwindcss_logo_icon_167923.png`,
    name:"Tailwindcss"
  },
  {
    img: `https://mui.com/static/logo.png`,
    name:'mui'
    },
   
    {
      img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSweFYSGs5msi-oMwKtBTePLiOM_jR6J5B3sw&usqp=CAU",
      name: "Bootstrap 5",
  },
  {
    img: "https://miro.medium.com/max/312/0*Z-jwqyt2k8NbHaQe.png",
    name:"Framer Motion"
    }
     
  
];
  
